/**
 * Partition des attendus par rubrique (programme 2025).
 *
 * Le back expose `rubrique` ∈ {'objectif', 'automatisme'} sur chaque attendu
 * (AttenduSerializer). Règle d'affichage : si le descripteur contient au
 * moins un automatisme, partition SYMÉTRIQUE en deux sections
 * « Objectifs d'apprentissage » et « Automatismes » (SeparateurRubrique) ;
 * un descripteur 100 % objectifs reste une liste nue, pas d'un pixel changé.
 *
 * Filtre sur la valeur back 'automatisme' (SINGULIER), jamais sur un libellé.
 * L'ordre d'origine est préservé dans chaque groupe, aucun tri.
 * Un attendu sans champ rubrique (vieux cache, référentiel non migré) est un
 * objectif : c'est le défaut du modèle back.
 */
export const partitionnerParRubrique = (attendus) => {
    const objectifs = [];
    const automatismes = [];
    (attendus || []).forEach((att) => {
        if (att && att.rubrique === 'automatisme') automatismes.push(att);
        else objectifs.push(att);
    });
    return { objectifs, automatismes };
};

/**
 * Ne garde que les attendus d'une rubrique — pour les contextes FILTRÉS
 * (décision 2026-08-18) : les pickers de séquence ne montrent que les
 * objectifs, le modal d'activité sert la rubrique de son type (Automatismes
 * → automatismes ; QFlash / Résolution → objectifs).
 */
export const attendusDeRubrique = (attendus, rubrique) =>
    partitionnerParRubrique(attendus)[rubrique === 'automatisme' ? 'automatismes' : 'objectifs'];
